export var EVENTS;
(function (EVENTS) {
    EVENTS["setOrganization"] = "set-organization";
    EVENTS["setProperties"] = "set-properties";
    EVENTS["setLocale"] = "set-locale";
})(EVENTS || (EVENTS = {}));
